import { eurDelta } from '../format'
import { SIGNALTEXT } from '../texte'
import type { NotierungSignal } from '../typen'

interface Eigenschaften {
  wert: number | null
  signal?: NotierungSignal | null
  /** „günstiger" / „teurer" hinter der Zahl - auf „Heute", wo der Platz da ist */
  inWorten?: boolean
  titel?: string
}

/**
 * Veränderung zum Vortag. Ein Rückgang ist für den Einkauf gut (grün), ein Anstieg schlecht (rot) -
 * aber das Vorzeichen steht immer dabei, und ein Signal trägt sein Wort („Signal", „stark", „Trend"),
 * damit nichts nur an der Farbe hängt.
 */
export default function Delta({ wert, signal, inWorten = false, titel }: Eigenschaften) {
  if (wert === null) return signal ? <SignalMarke signal={signal} /> : null
  const richtung = wert < -0.005 ? 'runter' : wert > 0.005 ? 'hoch' : 'gleich'
  return (
    <span className={`delta ${richtung}`} title={titel}>
      {eurDelta(wert)}
      {inWorten && richtung !== 'gleich' && <span className="delta-wort">{richtung === 'runter' ? ' günstiger' : ' teurer'}</span>}
      {signal && <SignalMarke signal={signal} />}
    </span>
  )
}

/** Das Signal als kleines Wort neben der Zahl; die lange Erklärung im Tooltip. */
export function SignalMarke({ signal }: { signal: NotierungSignal }) {
  return (
    <span className={`marke signal-${signal}`} title={SIGNALTEXT[signal].lang}>
      {SIGNALTEXT[signal].kurz}
    </span>
  )
}
